<template>
    <div class="AboutUs">
        <menuBox :step="2"></menuBox>
        <div class="about-box">
            <div>tentang kami</div>
            <p>Disiapkan dengan hati-hati, rasa lezatnya diwariskan. Bumbu kami membuat masakan Anda lebih kreatif.</p>
        </div>

        <div class="list-box">
            <div class="item">
                <p>100%</p>
                <div>Bahan-bahan alami berkualitas tinggi</div>
            </div>
            <div class="item">
                <p>100%</p>
                <div>Sehat dan lezat</div>
            </div>
            <div class="item">
                <p>4.93</p>
                <div>Diterima dengan baik oleh pelanggan</div>
            </div>
        </div>

        <div class="pencocokan">
            <div class="list-p">
                <div class="item">
                    <img src="../assets/about-2.png" alt="">
                    <div>Mudah digunakan</div>
                    <p>Bumbu kami mudah digunakan dan memberi Anda kendali atas dapur.</p>
                </div>
                <div class="item">
                    <img src="../assets/about-3.png" alt="">
                    <div>Bahan baku berkualitas tinggi</div>
                    <p>Proses pengadaan bahan baku dikontrol secara ketat, dan bahan baku dipilih dari sumber berkualitas tinggi di seluruh dunia untuk memastikan kesegaran dan kemurnian produk.</p>
                </div>
                <div class="item">
                    <img src="../assets/about-4.png" alt="">
                    <div>Pencocokan kreatif</div>
                    <p>Produk kami dapat memberi Anda inspirasi yang kaya dan serasi untuk membuat hidangan Anda lebih khas</p>
                </div>
            </div>
        </div>

        <div class="memasak">
            <img src="../assets/about-5.png" alt="">
            <div class="about-text">
                <div>Seni memasak, bumbu kami menambahkan sentuhan akhir pada masakan Anda.</div>
                <img src="../assets/about-6.png" alt="">
                <p>Produk kami tidak hanya sekedar bumbu, tapi juga seni kuliner. Berikan hidangan Anda kehidupan baru dan jadilah karya seni dalam hidup Anda.</p>
            </div>
        </div>

        <div class="bagus">
            <div class="bagus-text">
                <div class="title">Produk bagus, pilihan terbaik bagi pengguna</div>
                <p>Kami memiliki pabrik pengolahan bumbu yang profesional dan canggih, dan setiap produk dikontrol dengan ketat.Tidak hanya produknya dapat dipercaya, tetapi juga memiliki rasa yang kaya mempertahankan kelezatannya, tetapi juga membuatnya terasa lebih enak.</p>
                <!-- <div class="tle-box"><img src="../assets/tel.png" alt="">+800 1234 654 </div> -->
            </div>
            <img src="../assets/about-7.png" alt="">
        </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {
        aboutUs() {
            this.$router.push({ path: "aboutUs" });
        }
    }
}
</script>
<style lang="less" scoped>
.about-box {
    height: 600px;
    background-image: url(../assets/about-1.png);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    div {
        font-weight: bold;
        font-size: 62px;
        color: #FFFFFF;
    }

    p {
        font-weight: 400;
        font-size: 24px;
        color: #FFFFFF;
        margin-top: 20px;
    }
}

.list-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 110px 360px;

    .item {
        width: 400px;
        display: flex;
        align-items: center;
        justify-content: center;

        p {
            font-weight: 600;
            font-size: 50px;
            color: #FFA200;
        }

        div {
            font-weight: 400;
            font-size: 16px;
            color: rgba(51, 51, 51, 0.8);
            margin-left: 10px;
        }
    }
}

.pencocokan {
    padding: 0px 360px;
    margin-top: 50px;

    .list-p {
        display: flex;
        align-items: self-start;
        justify-content: space-between;

        .item {
            width: 385px;
            text-align: center;

            img {
                width: 385px;
            }

            div {
                font-weight: 600;
                font-size: 24px;
                color: #37393F;
                margin-top: 30px;
            }

            p {
                font-weight: 400;
                font-size: 16px;
                color: #7D7D7D;
                margin-top: 13px;

            }
        }
    }
}

.memasak {
    padding: 150px 360px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
        width: 560px;
    }

    .about-text {
        width: 600px;

        div {
            font-weight: bold;
            font-size: 30px;
            color: #252B42;
        }

        img {
            width: 600px;
            margin-top: 20px;
        }

        p {
            position: relative;
            width: 370px;
            min-height: 88px;
            background: #FFF8ED;
            box-shadow: 0px 5px 17px 0px rgba(23, 81, 81, 0.12);
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #FFFFFF;
            font-weight: 400;
            font-size: 18px;
            color: #333333;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 36px;
            margin-top: -80px;
            margin-left: 80px;
            z-index: 100;
        }
    }
}

.bagus {
    margin: 0px 360px;
    margin-bottom: 150px;
    background: #FFA200;
    border-radius: 30px;
    display: flex;
    align-content: center;
    justify-content: space-evenly;
    padding-bottom: 75px;

    img {
        width: 480px;
    }

    .bagus-text {
        width: 430px;

        .title {
            font-weight: bold;
            font-size: 36px;
            color: #FFFFFF;
            margin-top: 50px;
        }

        p {
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            margin-top: 28px;
        }

        .tle-box {
            width: 194px;
            height: 61px;
            background: #FFFFFF;
            border-radius: 42px 42px 42px 42px;
            font-weight: 600;
            font-size: 18px;
            color: #181818;
            margin-top: 18px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 22px;
            }
        }
    }
}
</style>
